/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable-next-line @typescript-eslint/no-var-requires */
import { Box } from '@chakra-ui/react'
import { ContentNotFound, Hero, Layout, Section, StickyHeader } from '@common'
import { ISSRPageData } from '@interfaces'
import { PageService } from '@services'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  //  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Image,
} from '@chakra-ui/react'

const ServicesAndAccessibilityScreen = ({
  pageData,
  global: { navigation },
}: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }

  return (
    <Layout
      title={pageData.data.pageTitle}
      navigation={navigation}
      path={asPath}
    >
      <Hero
        subTitle={pageData.data.hero.subTitle}
        title={pageData.data.hero.title}
        description={pageData.data.hero.description}
        bgImageUrl={pageData.data.hero.bgImageUrl}
      />

      {pageData.data.stickyNavItems &&
        pageData.data.stickyNavItems.length > 0 && (
          <Box as="main" pt={4}>
            <StickyHeader navs={pageData.data.stickyNavItems} />
          </Box>
        )}
      <Box as="main" pt={4}>
        {pageData.data.sections.map((section, index) => {
          return (
            index == 0 && (
              <Section
                sectionData={section}
                isLastItem={index + 1 === pageData.data.sections.length}
              />
            )
          )
        })}
      </Box>

      <Box as="main">
        <Box
          maxWidth="container.secondary"
          mx="auto"
          px={{ base: 'padding.primary', lg: '0' }}
        >
          {pageData.data.sections.map((section, index) => {
            return index == 0 && BasicUsage(section)
          })}
        </Box>
      </Box>
      <Box as="main" pt={4}>
        {pageData.data.sections.map((section, index) => {
          return (
            index == 1 && (
              <Section
                sectionData={section}
                isLastItem={index + 1 === pageData.data.sections.length}
              />
            )
          )
        })}
      </Box>
    </Layout>
  )
}

function BasicUsage(section: string[]) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button onClick={onOpen}>Detaylı İncele</Button>

      <Modal
        scrollBehavior="inside"
        allowPinchZoom={true}
        size="full"
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Müze Krokisi</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Image
              overflow="hidden"
              minWidth="1440"
              w={[1300, 1440, 1440]}
              src="https://drupal.sakipsabancimuzesi.org/sites/muze.sabanciuniv.edu/files/inline-images/web_kroki.jpg"
              alt="SSM Kroki"
            />
            <Box d="none">{JSON.stringify(section)}</Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ServicesAndAccessibilityScreen

export async function getStaticProps({ locale }) {
  const pageData = await PageService.getDefaultLayoutPageData(
    locale,
    'servicesAndAccessibility'
  )

  return {
    props: { pageData },
  }
}
